import { useEffect, useState } from 'react';
import { fetchOrderStockStatus, type OrderStockStatus } from '../api/orderStockStatusApi';

/**
 * Stock status of the customer order a draft ZD came from. A failed read (no
 * access, order gone) is `status: null`: the origin card then shows „—” in the
 * stock columns instead of failing or showing zeros.
 */
export default function useOriginStockStatus(orderId: string | null | undefined) {
  const [state, setState] = useState<{ orderId: string; status: OrderStockStatus | null } | null>(null);

  useEffect(() => {
    if (!orderId) return undefined;
    let active = true;
    fetchOrderStockStatus(orderId)
      .catch(() => null)
      .then((status) => { if (active) setState({ orderId, status }); });
    return () => { active = false; };
  }, [orderId]);

  const current = orderId && state && state.orderId === orderId ? state : null;
  return { status: current ? current.status : null, loading: Boolean(orderId) && !current };
}
